import { useAtom } from '@reatom/npm-react'

import { Numeric } from '@blade/ui-kit'
import { RankCard } from '@root/entities/leaderboard/ui'
import { profileAtom, tradingProfitUsdAtom } from '@root/entities/profile'

type RankCardProps = object

export const TradingRankCard: React.FC<RankCardProps> = () => {
  const [profile] = useAtom(profileAtom)
  const [tradingProfit] = useAtom(tradingProfitUsdAtom)
  const referralRank = profile?.tradeRank

  return (
    <RankCard
      rank={referralRank}
      variant="blue"
      endContent={
        <Numeric
          value={tradingProfit ?? 0}
          preset="currency-amount-short"
          currency="$"
        />
      }
    />
  )
}
